import React, { useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogBody,
  DialogTitle,
} from "../../design/dialog";
import { Button } from "../../design/button";
import { Text } from "../../design/text";
import { Subheading } from "../../design/heading";
import { InformationCircleIcon } from "@heroicons/react/20/solid";
import Banner from "../Banners/Banner";

const ContractsLearnMore: React.FC = () => {
  const [open, setOpen] = useState(false);

  const handleAction = () => {
    setOpen(true);
  };

  return (
    <>
      <Button plain onClick={handleAction}>
        <InformationCircleIcon className="w-5 h-5 mr-2" />
      </Button>
      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle>Contracts</DialogTitle>
        <DialogBody>
          <Banner isVisible={true} title={"🎉 Invoicing coming soon!"} />
          <Text>
            Keep track of all contract agreements between parents and
            supervisors in one place. Upload signed contracts and specify each
            parent’s financial responsibility for visitation costs. This ensures
            clarity and accountability throughout the visitation process.
          </Text>
          <Subheading className="my-4">How to Use:</Subheading>
          <Text>1) Upload contract agreements as files for each case.</Text>
          <Text>2) Choose the parent associated with the contract.</Text>
          <Text>
            3) Set the percentage of visitation costs each parent is responsible
            for.
          </Text>
        </DialogBody>
        <DialogActions>
          <Button plain onClick={() => setOpen(false)}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ContractsLearnMore;
